import { Form, Input } from "antd";
import PropTypes from "prop-types";
import React from "react";

const AddYear = ({ t, selectedYear, setSelectedYear, setSelectedCarModel }) => (
    <div>
        <p className="text-md font-medium mb-2">
            {t("car")} {t("year")}
        </p>
        <Form.Item>
            <Input
                type="number"
                placeholder={`${t("car")} ${t("year")}`}
                value={selectedYear}
                onChange={(e) => {
                    setSelectedYear(e.target.value);
                    setSelectedCarModel((prev) => ({
                        ...prev,
                        year: e.target.value,
                    }));
                }}
            />
        </Form.Item>
    </div>
);

AddYear.propTypes = {
    t: PropTypes.func.isRequired,
    selectedYear: PropTypes.string.isRequired,
    setSelectedYear: PropTypes.func.isRequired,
    setSelectedCarModel: PropTypes.func.isRequired,
};

export default AddYear;
